import React, { useEffect, useState, useReducer } from "react";
import Button from "./Button";
import Container from "./Container";
import Searchbar from "./Searchbar";
import Table1 from "./Table1";
import Dropdown from "./Dropdown";
import { reducer, initialState } from "../reducers/reducers";
import NewBudget from "./NewBudget";
import ViewBudget from "./ViewBudget";
import Urls from "../Urls";
import EditText from "./EditText";
import { useAuth } from "./AuthProvider";

const Budgeting = () => {
    const { canWrite, canRead } = useAuth();
    const [state, dispatch] = useReducer(reducer, initialState);
    const [fetchedData, setFetchedData] = useState([]);
    const [viewData, setViewData] = useState({});
    const [searchData, setSearchData] = useState("");

    // Estados para paginación
    const [page, setPage] = useState(1);
    const [perPage] = useState(15);
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [isSearching, setIsSearching] = useState(false);

    const fetchData = () => {
        // Permiso de lectura
        if (!canRead('acceso_notas_recepcion')) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            setFetchedData([]);
            setLastPage(1);
            setTotal(0);
            return Promise.reject('No tienes permisos para ver estos datos');
        }

        const paginatedUrl = `${Urls.BUDGETS}?page=${page}&per_page=${perPage}`;
        fetch(paginatedUrl, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then(resp => resp.ok ? resp.json() : Promise.reject(resp.statusText))
            .then(result => {
                if (result.data) {
                    setFetchedData(result.data);
                    setLastPage(result.last_page);
                    setTotal(result.total);
                } else {
                    setFetchedData(result);
                    setLastPage(1);
                    setTotal(result.length);
                }
            })
            .catch(console.error);
    };

    const search = () => {
        if (!searchData.trim()) return;

        // Permiso de lectura
        if (!canRead('acceso_notas_recepcion')) {
            console.error('No tienes permisos para ver estos datos');
            alert('No tienes permisos para ver estos datos');
            setFetchedData([]);
            setLastPage(1);
            setTotal(0);
            return Promise.reject('No tienes permisos para ver estos datos');
        }

        setIsSearching(true);
        setPage(1);

        fetch(`${Urls.BUDGETS}?search=${searchData}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
            .then(resp => resp.ok ? resp.json() : Promise.reject(resp.statusText))
            .then(data => {
                setFetchedData(data);
                setLastPage(Math.ceil(data.length / perPage) || 1);
                setTotal(data.length);
                setIsSearching(false);
                setPage(1);
            })
            .catch(err => { console.error(err); setIsSearching(false); });
    };

    useEffect(() => {
        if (!isSearching) fetchData();
    }, [page, isSearching]);

    // Controles de paginación con estilo de Clients.js
    function PaginationControls() {
        const buttonStyle = {
            backgroundColor: '#7AACE3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 16px',
            margin: '0 5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'background-color 0.3s'
        };
        const disabledButtonStyle = {
            ...buttonStyle,
            backgroundColor: '#cccccc',
            cursor: 'not-allowed',
            opacity: 0.7
        };
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '15px 0' }}>
                <button
                    onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    disabled={page === 1}
                    style={page === 1 ? disabledButtonStyle : buttonStyle}
                >
                    &lt; Anterior
                </button>
                <span style={{ margin: '0 15px', fontWeight: 'bold' }}>
                    Página {page} de {lastPage} ({total} registros)
                    {isSearching && ' - Resultados de búsqueda'}
                </span>
                <button
                    onClick={() => setPage(prev => Math.min(prev + 1, lastPage))}
                    disabled={page === lastPage}
                    style={page === lastPage ? disabledButtonStyle : buttonStyle}
                >
                    Siguiente &gt;
                </button>
            </div>
        );
    }

    return (
        <div className="anylayout">
            <div className="titleFont">Cotizaciones</div>
            <Container>
                <EditText onChange={setSearchData} text="Buscar..." />
                <Button text="Buscar" onClick={search} color="#7AACE3" />
                
                <Button text="Nueva Cotización" onClick={() => dispatch({ type: 'openNewBudget' })} color="#7AACE3" />
                
            </Container>

            <PaginationControls />
            <Table1 optview={true} onClickView={(data)=>{dispatch({type:'openViewBudget'});setViewData(data)}} headers={['Folio','Precio total','Descuento','Tipo','Fecha','idCliente','Nota de recepcion','Nombre de cliente']} data={fetchedData}></Table1>
<PaginationControls />            
{
                state.statusNewBudget && (<NewBudget onAccept={()=>{dispatch({type:'closeNewBudget'});fetchData()}} onClose={()=>{dispatch({type:'closeNewBudget'})}} ></NewBudget>)
            }
            {
                state.statusViewBudget && (<ViewBudget data={viewData} onClose={()=>{dispatch({type:'closeViewBudget'})}}></ViewBudget>)
            }
        </div>
    );
};

export default Budgeting;
